import styled from 'styled-components'

const CircularProgressStyled = styled.svg`
  border-radius: 50%;
  .circle {
    fill: none;
    stroke-width: ${({ thickness }) => `${thickness}px`};
    stroke: var(--turquoise);
    stroke-dasharray: ${({ progress, multiplier }) => `calc(${progress} * calc(5.65 * ${multiplier})) calc(5.65 * ${multiplier})`};
    transform: rotate(90deg);
    transform-origin: center;
  }
  .circle-bg {
    fill: none;
    stroke-width: ${({ thickness }) => `${thickness}px`};
    stroke: var(--neutral60);
  }
`

function CircularProgress({ diameter, progress, thickness, multiplier }) {
  const radius = diameter / 2
  return (
    <CircularProgressStyled
      height={diameter}
      width={diameter}
      xmlSpace="preserve"
      progress={progress}
      thickness={thickness}
      multiplier={multiplier}
    >
      <circle className="circle-bg" cx={radius} cy={radius} r={radius} transform={`rotate(270 ${radius} ${radius})`} />
      <circle className="circle" cx={radius} cy={radius} r={radius} transform={`rotate(270 ${radius} ${radius})`} />
    </CircularProgressStyled>
  )
}

export default CircularProgress
